export const buildAnswerUserMessage = (p: {
  question: string;
  toolContext: string[];
  plannerReply: string | null;
}): string => {
  const sections = [
    p.toolContext.length ? `Data hentet fra systemet:\n${p.toolContext.join("\n\n")}` : null,
    p.plannerReply !== null ? `Assistentens svar til brukeren:\n${p.plannerReply}` : null,
  ].filter((section): section is string => section !== null);
  return [`Spørsmål: ${p.question}`, ...(sections.length ? sections : ["(ingen data)"])].join("\n\n");
};
